import { AxiosResponse } from 'axios';
import { Request } from '../../api';
import { SimplePaginateResponse } from '../../app.types';
import { Organization } from '../../utils';

interface paramInterface {
    'filter[name]': string;
    perPage?: number | undefined;
}

const adminGetAllOrganizations = (
    searchTerm: string,
    perPage?: number | undefined,
): Promise<AxiosResponse<SimplePaginateResponse<Organization>>> => {
    let params: paramInterface = {
        'filter[name]': searchTerm,
    };

    if (perPage) {
        params = {
            'filter[name]': searchTerm,
            perPage: perPage,
        };
    }
    return Request.get('/admin/organizations', {
        params,
    });
};

type ReturnSingleOrganizationType = Promise<AxiosResponse<Organization>>;

const adminViewOrganization = (id: string): ReturnSingleOrganizationType => {
    return Request.get(`/admin/organizations/${id}`);
};

export { adminGetAllOrganizations, adminViewOrganization };
